import { Component, OnInit, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { DataService } from './data.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'] // usa el nuevo archivo SCSS del layout
})
export class AppComponent implements OnInit {
  title = 'Icetex - Oficina de Relaciones Internacionales';
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  items: any[] = [];
  sidebarVisible: boolean = false; // <--- cambia nombre aquí

  constructor(
    private router: Router,
    private data: DataService
  ) {
    this.setLoginDisplay();
  }



  ngOnInit(): void {
    const usuario = this.data.ObtenerUsuario();

    this.items = this.construirMenu(usuario);
    this.setLoginDisplay();
  }

  /** True si la ruta actual es la zona de participantes (Entra ID); no se muestra el layout principal */
  get esZonaParticipantes(): boolean {
    const url = this.router.url.split('?')[0].split('#')[0];
    return url.startsWith('/participantes');
  }

  setLoginDisplay() {
    this.data.usuarioAutenticado$.subscribe((usuarioAutenticado) => {
      this.loginDisplay = !!usuarioAutenticado;

      if (!this.loginDisplay) {
        const currentPath = this.router.url.split('?')[0].split('#')[0];
        const allowedPaths = ["/", "/crearcontrasena", "/diligenciar", "/participantes"];
        if (!allowedPaths.some(path => currentPath.startsWith(path))) {
          this.router.navigate(['/']);
        }
      } else {
        const usuario = this.data.ObtenerUsuario();
        
        this.items = this.construirMenu(usuario);
      }
    });
  }

  obtenerusuario() {
    return this.data.ObtenerUsuario();
  }

  abrirPagina(pagina: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/' + pagina]);
    });
    this.sidebarVisible = false;
  }

  logout() {
    sessionStorage.removeItem('token');
    this.data.cambiarEstadoUsuario();
    this.router.navigate(['/']);
  }

  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  }

  closeSidebarOnMobile() {
    if (window.innerWidth < 768) {
      this.sidebarVisible = false;
    }
  }

  private construirMenu(usuario: any): any[] {
    const esAdmin = usuario?.Rol === 'admin';
    const esSuperAdmin= usuario?.Email === 'guillermomerlano11@gmail.com';
    return [
      {
        label: 'Inicio',
        icon: 'pi pi-home',
        command: () => this.abrirPagina('formularios')
      },
      {
        label: 'Estrategias',
        icon: 'pi pi-user',
        command: () => this.abrirPagina('formularios')
      },
      {
        label: 'Patrocinadores',
        icon: 'pi pi-briefcase',
        command: () => this.abrirPagina('pppfa')
      },
      ...(esAdmin ? [{
        label: 'Configuración',
        icon: 'pi pi-cog',
        items: [

        ...(esAdmin ? [
        

          
          {
            label: 'Estrategias-Proyectos',
            icon: 'pi pi-list',
            command: () =>
              this.abrirPagina(
                'configuracion'+ `/68532ec386098b73c8ea4da8/68544d56bee0405bb5f3c4d3/68545321db1ca6993d67d7d5`
              )
          },
          {
        label: 'Flujo de datos',
        icon: 'pi pi-sitemap',
        command: () =>
              this.abrirPagina(
                'configuracion'+ `${environment.ruta_configuracion_mapeo}`
              )
      },
                    {
            label: 'Tableros PBI',
            icon: 'pi pi-chart-bar',
            command: () =>
              this.abrirPagina(
                'configuracion'+ `${environment.ruta_configuracion_reportes}`
              )
          }
      // {
      //   label: 'Reportes Excel',
      //   icon: 'pi pi-file-excel',
      //   command: () =>
      //         this.abrirPagina(
      //           'configuracion'+ `${environment.ruta_configuracion_reportesexcel}`
      //         )
      // }
    ] : []),

        ]
      }] : []),

      {
        label: 'Cerrar sesión',
        icon: 'pi pi-sign-out',
        command: () => this.logout()
      }
    ];
  }
}
